export type TimelineActionType =
  | {|
      type: 'FETCH_TIMELINE',
      payload: {| hideErrors: boolean, refresh: boolean |},
    |}
  | {|
      type: 'SET_TIMELINE',
      payload: {| timeline: Object[] |},
    |}
  | {|
      type: 'TOGGLE_TIMELINE_ITEM',
      payload: {| ouid: string |},
    |};

export const fetchTimeline = (refresh = false, hideErrors = false) => ({
  type: 'FETCH_TIMELINE',
  payload: { hideErrors, refresh },
});

export const setTimeline = (timeline: Object[]): TimelineActionType => ({
  type: 'SET_TIMELINE',
  payload: { timeline },
});

export const toggleTimelineItem = (ouid: string): TimelineActionType => ({
  type: 'TOGGLE_TIMELINE_ITEM',
  payload: { ouid },
});
